import React, {PureComponent} from 'react';
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./style.scss";
import {AppContext} from "../AppContext";
import Direction from "../../../Utils/Direction/Direction";

export default class AreYouSureDialog extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Dialog className="are-you-sure-dialog" open={this.props.open} onClose={this.props.onNo}>
                <DialogTitle>
                    {
                        this.props.titleText ?
                            <React.Fragment>
                                {this.props.titleText}
                            </React.Fragment>
                            :
                            <React.Fragment>
                                האם אתה בטוח?
                            </React.Fragment>
                    }
                </DialogTitle>
                <DialogActions className="are-you-sure-dialog-actions">
                    <Button variant="contained" onClick={this.props.onNo} className="no-button">
                        {
                            this.props.noText ?
                                <React.Fragment>
                                    {this.props.noText}
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    לא
                                </React.Fragment>
                        }
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.props.onYes} className="yes-button">
                        {
                            this.props.yesText ?
                                <React.Fragment>
                                    {this.props.yesText}
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    כן
                                </React.Fragment>
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}